import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function Analytics() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Typography variant='body2' color='text.secondary'>
        Analytics coming soon
      </Typography>
    </Box>
  );
}